// src/areas/areaApi.ts
import { apiClient } from "@maat/api-base";
var areaApi = {
  // `popular` asks the backend for only navigable popular destinations (popular
  // AND with a place id), so the guest drawer never filters client-side.
  getAreas: async (popular) => {
    return apiClient.get("/main/api/areas", {
      params: popular ? { popular: true } : void 0
    });
  },
  // The guest home's destination rail. Takes no parameters on purpose — the
  // server owns the cap and the ordering, which is what keeps its cache a
  // single entry on the platform's landing page.
  getFeaturedAreas: async () => {
    return apiClient.get("/main/api/areas/featured");
  }
};

export {
  areaApi
};
